import AlertMessages from "common/Alert/AlertMessages";
import BackendPaginationTable from "common/Table/TableWithPagination";
import { Box } from "@mui/material";
import { useGetSubscriptionPlanHistoryService } from "subModule/src/services/subscriptionplans/useSubscriptionPlan";
import Loader from "layout/Loader";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
interface SubscriptionPlanHistoryProps {
    businessPlanId?: number | null;
}
export const SubscriptionPlanHistory: React.FC<SubscriptionPlanHistoryProps> = ({ 
    businessPlanId
}) => {
    const [pageNo, setPageNo] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const { data: tableData, isFetching, refetch } = useGetSubscriptionPlanHistoryService({ pageNumber: pageNo, size: pageSize, businessPlanId: businessPlanId || null });
    const { enqueueSnackbar } = useSnackbar();
    const fetchData = useCallback(() => {
        refetch().then((res: any) => {
            if (!res?.data?.pages[0]?.success) enqueueSnackbar(<AlertMessages text={res?.data?.pages[0]?.message || "Something went wrong"} />, { variant: "error" });
        });
    }, []);
    useEffect(() => {
        fetchData();
    }, [pageNo, pageSize]);
    const handleChangePage = (pageNo: number) => {
        setPageNo(pageNo + 1);
    }
    const handleChangeRows = (pageSize: number) => {
        setPageSize(pageSize);
        setPageNo(1);
    }
    return (
        <Box>{isFetching ? <Loader /> :
            <Box id="mainListingTable" className="mt-[10px]">
                <BackendPaginationTable
                    columns={[
                        { id: 'newPlanTitle', label: 'title', numeric: false },
                        { id: 'newStatus', label: 'status', numeric: false },
                        { id: 'oldPlanStartDate', label: 'startDate', numeric: false },
                        { id: 'oldPlanEndDate', label: 'endDate', numeric: false },
                    ]}
                    data={tableData?.pages[0]?.data?.content || []}
                    pageNo={pageNo}
                    pageSize={pageSize}
                    tableData={tableData?.pages[0]?.data || {}}
                    showCheckbox={false}
                    showActions={true}
                    enableSorting={false}
                    showHeader={false}
                    showSearch={false}
                    showFilter={true}
                    showCreateButton={false}
                    actions={[]}
                    handleChangePage={handleChangePage}
                    handleChangeRows={handleChangeRows}
                    rowClick={true}
                    loadingSearch={false}
                    headerComponent={<></>}
                    HideStickyHeader={true}
                />
            </Box>}
        </Box>
    )
};